import { render } from "./NormalHeader.vue?vue&type=template&id=f9fe8a38&scoped=true"
import script from "./NormalHeader.vue?vue&type=script&lang=js"
export * from "./NormalHeader.vue?vue&type=script&lang=js"

import "./NormalHeader.vue?vue&type=style&index=0&id=f9fe8a38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9fe8a38"]])

export default __exports__